import React, {Component} from 'react';
import {translate} from 'react-i18next';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {Table} from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';
import WaitingModal from '../../generics/WaitingModal';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import swal from 'sweetalert';
import moment from 'moment';
import Moment from 'react-moment';
import Notifications, {notify} from 'react-notify-toast';
import {priceTag} from 'react-icons-kit/icomoon/priceTag';
import Help from '../../generics/help';
import Inputmask from 'inputmask';

import {Typeahead} from 'react-bootstrap-typeahead';
import $ from 'jquery';

var Config = require('../../../config');

class PoolsReconstruction extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.addComponent = this.addComponent.bind(this);
		this.onChecked = this.onChecked.bind(this);
		this.onCreate = this.onCreate.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onChangeComponent = this.onChangeComponent.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.onPrint = this.onPrint.bind(this);
		this.clearValues = this.clearValues.bind(this);
		this.getFinalComponent = this.getFinalComponent.bind(this);

		var aux_date = new Date();

		this.state = {
			date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			hour 	: "",
			end_hour: "",
			submenu	: "",
			code:"",
			//code_component: "",
			unit_number : "",
			component_number: "",
			code_required: false,
			components:[],
			checks:[],
			blood_component_id:"",

			code_pool:"",
			component_pool:"",
			unit_number_pool:"",
			volume_pool:"",
			bag_lot:"",
			aditive_solution:"",
			hematocrit:"",
			date_form:"",
			hour_form:"",
			new_unit_id:"",
			group_rh:"",
			group_rh_list:[],

			code_component_list:[],

			isLoading:false,
			caducidad:"",
			rec_pool_system:"",
			rec_pool_cad:"",

			same_date:"",
			isogrupo:"NO",
			permite_plaqueta:"NO",
			sys_component:"CERRADO",
			cad_from:"",
			cad_hour:"",	
			preview_print:{},
			new_id:"",
			btn_new:false,
			final_component:"",
			final_components:[],
			max_hour:"",
			min_hour:""
		}
	}

	validInputDate(message, id){
		if(message !== ""){
			swal('Error', message, 'error');
			
			setTimeout(()=>{
				$('#'+id).val('')
					.attr('type', 'text')
					.attr('type', 'date');
			}, 4000);

			$('#'+id).addClass('error');
		}else{
			$('#'+id).removeClass('error');
		}
	}

	componentDidMount(){
		$(document).on('blur', '#date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		$(document).on('blur', '#caducidad', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});


		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}

		var selector = document.getElementById('hour');
		var im = new Inputmask("--:--");
		im.mask(selector);

		this.getTimeServer();

		var submenu = this.props.match.path.replace('/', '');
		this.setState({submenu:submenu})

		if(submenu !== 'pools'){
			this.getCriterial('REC_TYPE_SIS', 'rec_pool_system');
			this.getCriterial('REC_CAD_PROC', 'rec_pool_cad');

			this.props.waiting.handleShow('Cargando...');
			setTimeout(()=>{
				this.props.waiting.handleClose();
			}, 300)
		}else{
			this.getCriterial('POOL_SAME_DATE', 'same_date');
		}		

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		});
	}

	getFinalComponent(component){
		fetch(Config.default.apiGateway.URL+'blood_component/pools_by_component?component_type='+component, {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({final_components:response});

      			if(response.length === 1){
      				this.setState({final_component:response[0].id});
      			}
      		}
      	});
	}

	getCriterial(code, state){
		
		var submenu = this.props.match.path.replace('/', '');

		//this.waiting_modal.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'functional_criterion?code='+code, {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({[state]:response.value});
      			
  				if(state === 'cad_from'){
      				if(response.value === 'PROCESS' && submenu === 'pools'){
      					setTimeout(()=>{
      						var datetime = moment(this.state.date+' '+this.state.hour).add(this.state.cad_hour, 'hours').format('YYYY-MM-DDTHH:mm');

	      					this.setState({
	      						caducidad: datetime,
	      					});
      					}, 500);
	      					
      				}
      			}
      					
      		}
      	});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getTimeServer(){
		var submenu =  this.props.match.path.replace('/', '');

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split('/').reverse().join('-')
			var hours = this.getHourFormat(aux[1]);

			setTimeout(function(){
				var datetime = moment(date+' '+hours).add(this.state.rec_pool_cad, 'hours').format('YYYY-MM-DDTHH:mm');

				var min_hour = moment(date+' '+hours).subtract('6', 'hours').format('HH:mm');
      			var max_hour = hours;
				this.setState({
					date:date,
					hour:hours,
					caducidad: submenu !== 'pools' ? datetime : "",

					min_hour: min_hour,
					max_hour: max_hour
				});

			}.bind(this), 500);
				
		})
	}

	componentDidUpdate(){
		if(this.props.search !== this.state.submenu){
			var submenu = this.props.match.path.replace('/', '');

			this.setState({
				submenu:this.props.search,
				hour 	: "",
				code 	: "",
				unit_number : "",
				component_number: "",
				code_required: false,
				components:[],
				checks:[],

				code_pool:"",
				component_pool:"",
				unit_number_pool:"",
				volume_pool:"",
				bag_lot:"",
				aditive_solution:"",
				hematocrit:"",
				date_form:"",
				hour_form:"",
				new_unit_id:"",
				group_rh:"",
				rec_pool_cad:"",
				rec_pool_system:"",
				isogrupo:"NO", 
				permite_plaqueta:"NO",
				new_id:"",
				btn_new:false
			});

			if(submenu !== 'pools'){
				this.getCriterial('REC_TYPE_SIS', 'rec_pool_system');
				this.getCriterial('REC_CAD_PROC', 'rec_pool_cad');
			}
			this.resetValidation();

			this._typeahead.getInstance().blur();
			this._typeahead.getInstance().clear();

			setTimeout(()=>{
				this.waiting_modal.handleClose();
			}, 1000)
	    }
	}

	handleChange(e){
		if(e.target.name === 'unit_number'){
			document.getElementById('unit_number').classList.remove("error");
		}

		var campo = e.target.name;
		

		if(e.target.name === 'hour'){
			var submenu = this.props.match.path.replace('/', ''); 

			this.setState({
				[campo]: e.target.value
			});

			var hour = moment(e.target.value, 'h:mm');
			var max = moment(this.state.max_hour, 'HH:mm');
			var min = moment(this.state.min_hour, 'HH:mm')
			
			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");

				if(submenu === 'pools'){
					if(hour <= max && hour >= min){
						this.setState({
							[campo]: e.target.value
						});

					}

					if(hour > max && hour >= min){
						this.setState({
							[campo]: max.format('HH:mm')
						});	
					}

					if(hour < min && hour <= max){
						this.setState({
							[campo]: min.format('HH:mm')
						});
					}

					setTimeout(()=>{
						var datetime = moment(this.state.date+' '+this.state.hour)
										.add(this.state.cad_hour, 'hours')
										.format('YYYY-MM-DDTHH:mm');	

						this.setState({
							caducidad: datetime
						})
					}, 500);
					
				}
					
			}

			
		
		}else{
			this.setState({
				[campo]: e.target.value
			});
			setTimeout(function(){
				this.showCtrlError(campo);
			}.bind(this), 500);
		}
	}

	addComponent(){
		var submenu = this.props.match.path.replace('/', '');

		if(this.state.code === "" && this.state.unit_number === ""){
			swal('Error', 'Campos número de unidad y código son requeridos', 'error');
			document.getElementById('unit_number').classList.add("error");
			document.getElementById("code").style.boxShadow = "0 0 5px 1px red";

		}else if(this.state.code === "" && this.state.unit_number !== ""){
			swal('Error', 'Campo código es requerido', 'error');
			document.getElementById("code").style.boxShadow = "0 0 5px 1px red";
		
		}else if(this.state.code !== "" && this.state.unit_number === ""){
			swal('Error', 'Campo número de unidad es requerido', 'error');
			document.getElementById('unit_number').classList.add("error");
		
		}else{
			document.getElementById('unit_number').classList.remove("error");
			document.getElementById("code").removeAttribute("style");

			var proceso = "";
			submenu === 'pools' ? proceso = 'pools' : proceso='reconstitution'

			this.waiting_modal.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'units/by_code_component?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+
				'&code='+this.state.code+"&unit_number="+this.state.unit_number+"&component_number="+this.state.component_number+
				"&process="+proceso, {
				method : 'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => {
		          this.waiting_modal.handleClose();
		            if(res.ok){
		              return res.json();
		            }else{
		              res.text().then(function(error) {
		                swal('¡Error!', error, 'error');
		              });
		          }
		      })
			.then(response => {
				if(response !== undefined){
					if(response.units.length > 0){
						if(submenu === 'pools'){
							if(this.state.final_components.length === 0){
					   			this.getFinalComponent(response.blood_component.component_type);
					   		}
						}

						response.units.map(function(u, x){
							return u.map((d, i)=>{
								var igual = 0;
								var diferente = 0;
								var dif_rh = true;
								var mensaje = "";
								var dif_cad = false;
								var group = d.unit.group;
								var rh = d.unit.rh === "POSITIVO" ? "+" : d.unit.rh === "NEGATIVO" ? "-" : "" ;;

								if(this.state.group_rh === "" && submenu !== 'pools'){
									if(d.blood_component.component_type === "CONCENTRADO_ERITROCITARIO"){
										this.setState({
											group_rh:group+rh
										});
									}
								}

								if(submenu === 'pools'){
									if(this.state.checks.length === 1){
										switch(this.state.checks[0].component){
											case 'PLAQUETAS':
												this.getCriterial('PLATELETS_POOL_UNITS_ISO', 'isogrupo');
												this.getCriterial('PLATELETS_POOL_ADD_PLASMA', 'permite_plaqueta');
												this.getCriterial('PLATELETS_POOL_SYS_TYPE', 'sys_component');
												this.getCriterial('PLATELETS_POOL_CAD_HRS', 'cad_hour');
												this.getCriterial('PLATELETS_POOL_CAD_FROM', 'cad_from');
												break;
											case 'PLASMA':
												this.getCriterial('PLASMA_POOL_UNITS_ISO', 'isogrupo');
												this.getCriterial('PLASMA_POOL_SYS_TYPE', 'sys_component');
												this.getCriterial('PLASMA_POOL_CAD_HRS', 'cad_hour');
												this.getCriterial('PLASMA_POOL_CAD_FROM', 'cad_from');
												break;
											case 'CRIOPRECIPITADOS':
												this.getCriterial('CRIO_POOL_UNITS_ISO', 'isogrupo');
												this.getCriterial('CRIO_POOL_SYS_TYPE', 'sys_component');
												this.getCriterial('CRIO_POOL_CAD_HRS', 'cad_hour');
												this.getCriterial('CRIO_POOL_CAD_FROM', 'cad_from');
												break;
										}
										
									}

									setTimeout(()=>{
										this.state.checks.some((c)=>{
											if(c.id === d.unit.id){
												igual++;
											}else if(c.component !== d.blood_component.component_type){
												if(c.component === 'PLAQUETAS'){
													if(this.state.permite_plaqueta === 'NO'){
														diferente++;
													}
												}else{
													diferente++; //diferente componente
												}
												
											}else if(c.group_rh !== group+rh){
												
												if(this.state.isogrupo !== 'NO'){
													
													dif_rh = false;
												}
											}

											if(this.state.same_date === 'YES'){
											
												if(c.caducidad !== d.unit.caducidad){
													
													dif_cad = true;
												}
											}
										});
									}, 500)
											
								}else{

									var num_CE = 1 //concentrado eritrocitario
									var num_CE_tabla = 0;
									var num_PF = 2	//plasma fresco
									var num_PF_tabla = 0;
									var num_P = 1	//plaquetas
									var num_P_tabla = 0;
									this.state.checks.map((c)=>{
										if(c.id === d.unit.id){
											igual++
										}else{
											if(c.component === 'CONCENTRADO_ERITROCITARIO' && c.component === d.blood_component.component_type){
												num_CE_tabla++

											}else if(c.component === 'PLASMA' && c.component === d.blood_component.component_type){
												num_PF_tabla++

											}else if(c.component === 'PLAQUETAS' && c.component === d.blood_component.component_type){
												num_P_tabla++
											}
										}

									});

									if(num_CE_tabla === num_CE){
										mensaje += "El proceso solo permite un componente de tipo Concentrado Eritrocitario\n";
									}
									if(num_PF_tabla === num_PF){
										mensaje += "El proceso solo permite máximo 2 componentes de tipo Plasma\n"
									}
								}

								setTimeout(()=>{
									
									if(mensaje !== ""){
										swal("Error", mensaje , 'error');


									}else if(igual !== 0){
										swal("Error", "El componente ya fue ingresado en la tabla." , 'error');

									}else if(diferente !== 0){
										swal("Error", "El componente que intenta igresar es de  diferente tipo  a los ingresados en la tabla.", 'error');									
									}else if(!dif_rh){
										swal("Error", "El componente que intenta igresar contiene un Grupo y RH distinto a los ingresados en la tabla.", 'error');
									}else if(dif_cad){
										swal('Error', 'La fecha de caducidad de los componentes de pool deben de ser la misma.', 'error');
									}else{

										var volume = this.state.volume_pool === "" ? 
														0 + parseInt(d.unit.volume) 
													: parseInt(this.state.volume_pool) + parseInt(d.unit.volume);

										this.setState({
											checks: [...this.state.checks, {
														id:d.unit.id, 
														code:this.state.code, 
														value:d.unit.volume, 
														component_number: d.unit.component_number ,
														component: d.blood_component.component_type,
														group_rh: group+rh,
														check: submenu === 'pools' ? true : false,
														caducidad: d.unit.caducidad
													}],
											components: [...this.state.components, d],
											volume_pool: volume,
											
										})

										

										if(submenu === 'pools'){
											if(this.state.cad_from !== 'PROCESS'){
												this.setState({
													caducidad: d.unit.caducidad
												})
											}
											
											//almacenamiento de group_rh para pools
											this.state.checks.some((c)=>{
												var indexRh = this.state.group_rh_list.findIndex(obj => obj.group === c.group_rh);

												if(indexRh === -1 && c.group_rh !== ""){

													this.setState({
														group_rh_list: [...this.state.group_rh_list, {group: c.group_rh}]
													});
												}

												if(this.state.cad_from !== 'PROCESS'){
													
													if(c.caducidad > this.state.caducidad){
														this.setState({
															caducidad: this.state.caducidad
														});
													}else{
														this.setState({caducidad: c.caducidad});
													}
												}
											});
										}

										this._typeahead.getInstance().clear();

										this.setState({
											blood_component_id: response.blood_component.id,
											code_required:false,
											code: "",
											unit_number:"",
											component_number:"",
											code_component_list:[]
										});
									}
								},800)
							})
						}.bind(this))

					}else{
						swal('Búsqueda sin resultados', "", 'warning');
					}
				}
			});
			
		}
	}

	onSearch(){
		if(this.isValidSearch()){
			this.setState({
				aliquots:[],
				components:[],
				blood_process:[],
			});

			this.waiting_modal.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'units/by_code_component?code='+this.state.code_component+
				"&unit_number="+this.state.unit_number+"&component_number="+this.state.component_number, {
				method : 'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => {
				this.waiting_modal.handleClose();
		        if(res.ok){
		          return res.json();
		        }else{
		          res.text().then(function(result) {
		            swal('¡Error!', result, 'error');
		            return;
		          });
		        }})
			.then(response => {
				if(response !== undefined){
					var valid = true;

					if(response.units.length > 0){
						switch(response.units.length){
							case 0 :
								swal('Búsqueda sin resultados', "", 'warning');
							break;
							case 1://Busqueda exitosa
								response.units.map(function(u, x){
									return u.map((d, i)=>{
										if(d.status !== 'BLOQUEADA'){
											this.setState({aliquots: [...this.state.aliquots, d]});

											this.table.setState({
												component:[...this.table.state.component, 
														  {
															id:d.unit.id, 
															volume:d.unit.volume, 
															value:"", 
															input:"", 
															check:false
														  }]
											})
										}else{
											valid = false;
										}
									})
								}.bind(this));

								if(valid){
									this.setState({component_id:response.blood_component.id});

									response.blood_component_has_blood_process.map(function(blood, i){
										return this.setState({
											blood_process : [...this.state.blood_process, blood]
										})
									}.bind(this));

									setTimeout(function(){
										this.inputRef.focus();
									}.bind(this), 500);
								}else{
									swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');

									this._typeahead.getInstance().blur();
									this._typeahead.getInstance().clear();
									this._typeahead.getInstance().focus();
								}
									
							break;
							default://Seleccionar numero de componente
								var component_numbers = [];
								for(var i=0;i < response.units[0].length;i++){
									component_numbers.push(response.units[0][i].unit.component_number);
								}
								this.setState({component_numbers:component_numbers});
								swal("",'Seleccione un número de componente y vuelva a buscar', 'warning');
							break;
						}
					}else{
						swal('Búsqueda sin resultados', "", 'warning');
					}
				}
			});
		}
	}

	deleteComponent(id){
		var submenu = this.props.match.path.replace('/', '');

		if(this.state.cad_from !== "PROCESS" && submenu === 'pools'){
			this.setState({caducidad:""});
		}
		
		this.state.components.map((c, i)=>{
			if(id === c.unit.id){
				if(this.state.volume_pool !== ""){
					var volume = parseInt(this.state.volume_pool) - parseInt(c.unit.volume);
					this.setState({
						volume_pool: volume === 0 ? "" : volume
					});
				}

				if(c.blood_component.component_type === "CONCENTRADO_ERITROCITARIO"){
					this.setState({
						group_rh:"",
						group_rh_list:[]
					});
				}

				this.state.components.splice(i, 1);
				this.state.checks.splice(i, 1);
				if(submenu === 'pools'){
					setTimeout(function(){
							//almacenamiento de group_rh para pools
						this.state.checks.some((c)=>{
							var indexRh = this.state.group_rh_list.findIndex(obj => obj.group === c.group_rh);

							if(indexRh === -1 && c.group_rh !== ""){
								this.setState({
									group_rh_list: [...this.state.group_rh_list, {group: c.group_rh}]
								});
							}

							if(this.state.cad_from !== 'PROCESS'){
													
								if(c.caducidad > this.state.caducidad){
									this.setState({
										caducidad: c.caducidad
									});
									return;
								}
							}
						})
					}.bind(this), 500)
					
				}
			}
		});

		this.forceUpdate();
	}

	onChecked(e){
		this.state.checks.map((c, i)=>{
			return parseInt(e.target.id) === c.id ?
					c.check = c.check ? false : true
				: null
		});

		this.forceUpdate();
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null)
    					form.elements[index + 1].focus();
    			
    				else if(form.elements[index + 1].getAttribute("disabled") === "")
    					form.elements[index + 5].focus();
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	onCreate(){ 
  		var submenu = this.props.match.path.replace('/', '');
  		var url = "";
  		var mensaje = "La tabla debe contener\n";
  		var volume = 0;

  		if(submenu === 'pools'){
  			url = 'units/pool?blood_component_id=';

  			var valores = 0
  			var units = [];
  			this.state.checks.map((c)=>{
				if(!c.check){
					valores++;	
				}else{
					units.push(c.id);
				}
			});

			if(units.length < 2){
				mensaje += "al menos dos componentes seleccionados."
			}
  		}else{
  			url = 'units/reconstitution?option=';

  			var num_CE = 1 //concentrado eritrocitario
			var num_CE_tabla = 0;
			var num_PF = 2	//plasma fresco
			var num_PF_tabla = 0;
			var num_P = 1	//plaquetas
			var num_P_tabla = 0;
			
			this.state.checks.map((c)=>{
				if(c.component === 'CONCENTRADO_ERITROCITARIO'){
						num_CE_tabla++

				}else if(c.component === 'PLASMA'){
					num_PF_tabla++

				}else if(c.component === 'PLAQUETAS'){
					num_P_tabla++
				}
			});

			if(num_CE_tabla > num_CE || num_CE_tabla === 0){
				mensaje += "- 1 Concentrado Eritrocitario\n";
			}
			if(num_PF_tabla > num_PF || num_PF_tabla === 0){
				mensaje += "- 1 ó 2 Plasmas Frescos\n"
			}

			if(num_P_tabla > num_P){
				mensaje += "- 0 ó 1 Plaqueta (No obligatorio)"
			}
  		}		

		if(mensaje.length > 25){
			swal("Error", mensaje, 'warning')
		}else{
			var error = ''
			
			if(this.state.group_rh === ""){
				error += 'Debe seleccionar un Grupo Sanguíneo';

				document.getElementById('group_rh').classList.add('error');
			}

			if(submenu === 'pools'){
				if(this.state.final_component === ""){
					error += (error === '' ? 'Debe seleccionar un componente final' : ' y componente final');

					document.getElementById('final_component').classList.add('error');
				}
			}

			if(error === ''){
				var index_rh = this.state.group_rh.indexOf('+') !== -1 ? this.state.group_rh.indexOf('+') : this.state.group_rh.indexOf('-');
				var group 	 = this.state.group_rh.substring(0, index_rh);
				var rh 		 = this.state.group_rh.substring(index_rh);
				rh = rh === "+" ? "POSITIVO" : "NEGATIVO";

				this.waiting_modal.handleShow('Creando...');
				if(units === undefined){
					units = "";
				}
		  		fetch(Config.default.apiGateway.URL+url+this.state.blood_component_id+"&health_facilities_id="+
		  			sessionStorage.getItem("health_facilities_id")+'&group='+group+'&rh='+rh+
		  			(submenu === 'pools' ? '&final_component_id='+this.state.final_component : ''), {
		  			method : 'post',
		  			body: JSON.stringify(units),
		  			headers: new Headers({
		  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
		  				'Accept'		: 'application/json',
		  				'Content-Type'	: 'application/json'
		  			})
		  		}).then(res => {
		  			this.waiting_modal.handleClose();
		  			if(res.ok){
		  				return res.json();
		  			}else{
		  				return res.text()
		  			}
		  		})
		  		.then(response=>{
		  			if(response.unit !== undefined){
		  				notify.show("Creando correctamente.", 'success')
		  				this.setState({
			  				new_unit_id:response.unit.id,
			  				code_pool: response.blood_component.code,
			  				component_pool:response.blood_component.component,
			  				unit_number_pool: response.unit.unit_number,
			  				//volume_pool: volume
			  			})
		  			}else{
		  				swal("Error", response, 'error');
			  		}	
		  		})
			}else{
				swal('Error', error, 'error');
				
			}

			/*
				*/
	  	}
  	}

  	onSave(){  
  		if(this.isValidDate(this.state.date)){		
	  		var submenu = this.props.match.path.replace('/', '');
	  		var obj = {};
	  		var url = "";
	  		var unit = [];

	  		var date = moment(this.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');
			var hour = moment(this.state.hour, 'h:mm a');
			var caducidad = moment(this.state.caducidad, 'YYYY-MM-DD H:mm');

			obj.date = date.format('MM-DD-YYYY');;
			obj.hour = this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('H:mm');
			obj.caducidad = caducidad.format('MM-DD-YYYY H:mm');
			obj.health_facilities_id = sessionStorage.getItem('health_facilities_id');

			obj.bag_lot = this.state.bag_lot;
			obj.total_volume = this.state.volume_pool;
			obj.new_unit_id = this.state.new_unit_id;

			var index_rh = this.state.group_rh.indexOf('+') !== -1 ? this.state.group_rh.indexOf('+') : this.state.group_rh.indexOf('-');
			var group 	 = this.state.group_rh.substring(0, index_rh);
			var rh 		 = this.state.group_rh.substring(index_rh);

			obj.group = group;
			obj.rh = rh === "+" ? "POSITIVO" : "NEGATIVO";

			this.state.checks.map((c)=>{
				if(this.state.submenu === 'pools'){
					if(c.check){
						unit.push({
							unit_id: c.id,
							volumen: c.value
						})
					}
						
				}else{
					unit.push({
						unit_id: c.id,
						volumen: c.value
					});		
				}
			});

			if(submenu === 'pools'){
				obj.aditive_solution = this.state.aditive_solution
				obj.pools_parts = unit;

				url = 'pools_process';
			}else{
				obj.hematocrit = this.state.hematocrit;
				obj.reconstitution_parts = unit;

				url = 'reconstitution_process';
			}
			if(this.state.new_unit_id === ""){
				swal("Error", "Para poder guardar los datos, debe crear el nuevo componente.", 'error');
			}else if(obj.hour === "Invalid date"){
				notify.show("Error, Hora invalida", 'error');
			}else{
				if(this.isValidForm()){									
					this.waiting_modal.handleShow('Guardando...');
					fetch(Config.default.apiGateway.URL+url,{
						method: 'post',
						body: JSON.stringify(obj),
						headers: new Headers({
							'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					}).then(res => {
						this.waiting_modal.handleClose();
						if(res.ok){
							return res.json()
						}else{
							res.text().then(function(result){
								swal("Error", result, 'error');
							})
						}
					})
					.then(response=>{
						swal('¡Buen Trabajo!', "Proceso Terminado", 'success');
						

						if(submenu === 'pools'){
							this.setState({new_id:response.new_unit_id, btn_new:true});
							//this.onPrint(response.new_unit_id);
							/*setTimeout(()=>{
								this.props.history.push('/pools_list');
							}, 500);*/
							
						}else{
							this.setState({
								//hour 	: "",
								code 	: "",
								unit_number : "",
								component_number: "",
								code_required: false,
								components:[],
								checks:[],
								blood_component_id:"",

								code_pool:"",
								component_pool:"",
								unit_number_pool:"",
								volume_pool:"",
								bag_lot:"",
								aditive_solution:"",
								hematocrit:"",
								date_form:"",
								hour_form:"",
								new_unit_id:"",
								group_rh:""
							})
						}
					});								
				}else{
					notify.show("Campos incompletos.", 'error');		
				}			
			}
		}else{
			notify.show('Error, Fecha no válida','error');
		}
  	}

  	onPrint(){
		this.props.waiting.handleShow('Imprimiendo...');
          
		var units = [this.state.new_id];

		fetch(Config.default.apiGateway.URL+'labelsEditor/print_bag_labels?health_facilities_id='+
			sessionStorage.getItem('health_facilities_id'), {
			method : 'post',
			body:JSON.stringify(units),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then(function(result) {
					swal('¡Error!', result, 'error');
					return;
				});
			}
		}).then(response => {
			if(response !== undefined){
				if(this.state.preview_print.value === "NO"){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = ()=>{
						var base64data = reader.result;  
						var aux = base64data.split(',');
						this.props.socket.send('{"Operacion":"print", "Type":"label_bags", "File": "'+aux[1]+'"}');
					}
				}

			}
		});
	}

  	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

  	isValidForm() {
		const select = document.querySelector('div.reconstitution');
		const inputs = select.querySelectorAll('input, select');

	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	showCtrlError(refName) {
		
		var res = null;
		var control = document.getElementById(refName);

		if(control.required){
			if (control.value === "") {
				if(control !== null){
					control.classList.add('error');
				}
				res = false;
			} else{
				if(control !== null){
					if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}
				}
				res = true;
			}
		}

		return res;
	}

	resetValidation(){
		const inputs = document.querySelectorAll('select,input');
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		var control = document.getElementById(input.name);
	    		if(control !== null){
		    		if(control.required && control.className.includes('error')){
						control.classList.remove('error');
					}		    	
				}
		  	}
	    });
	}

	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			//this.validateInput(e);
			this._typeahead.getInstance().clear();

			var submenu = this.props.match.path.replace('/', '');
			var option = submenu == "pools" ? "pools_search" : "reconstitution_search";

			fetch(Config.default.apiGateway.URL+'units/'+option+'?health_facilities_id='+sessionStorage.getItem('health_facilities_id')+
				'&unit_number='+e.target.value, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg=>{
						swal("Error", msg, 'error')
					});

					document.getElementById('unit_number').focus();
				}
			})
			.then(response=>{
				if(response !== undefined){
					this.setState({
						code_component_list: response
					});
					this._typeahead.getInstance().focus();
				}else{
					this.setState({
						code_component_list: []
					})
				}
			})
		}
	}

	onChangeComponent(e){
		if(e.length > 0){
			
			if(e[0].unit_status !== 'BLOQUEADA'){
				this.setState({
		   			isLoading:true
		   		});
				setTimeout(function(){
					var component = e[0].label.split(' ')[0];
					var number = e[0].label.split(' ')[1];
					this.setState({
			   			code: component,
			   			component_number: number,
			   			isLoading:false
			   		});

				}.bind(this), 1000);
			}else{
				swal('Error', 'El componente que intenta seleccionar se encuentra bloqueado', 'error');

				this._typeahead.getInstance().blur();
				this._typeahead.getInstance().clear();
				this._typeahead.getInstance().focus();
			}
		}
	}

	onReturn(){
		if(this.props.history.location.pathname.includes("reconstitucion")){
			this.props.history.push('/');	
		}else{
			this.props.history.push('/pools_list');
		}
	}

	clearValues(){

		this.setState({
			hour 	: "",
			end_hour: "",
			submenu	: "",
			code:"",
			//code_component: "",
			unit_number : "",
			component_number: "",
			code_required: false,
			components:[],
			checks:[],
			blood_component_id:"",

			code_pool:"",
			component_pool:"",
			unit_number_pool:"",
			volume_pool:"",
			bag_lot:"",
			aditive_solution:"",
			hematocrit:"",
			date_form:"",
			hour_form:"",
			new_unit_id:"",
			group_rh:"",
			group_rh_list:[],

			code_component_list:[],

			isLoading:false,
			//caducidad:"",
			rec_pool_system:"",
			rec_pool_cad:"",

			same_date:"",
			isogrupo:"NO",
			permite_plaqueta:"NO",
			sys_component:"CERRADO",
			cad_from:"",
			cad_hour:"",	
			preview_print:{},
			new_id:"",
			btn_new:false,
		});

		this.getTimeServer();
	}

	

	render(){
		const {t} = this.props;
		var submenu = this.props.match.path.replace('/', '');

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.'+submenu+'.MAIN')}
					</h5>
				</div>
				{submenu !== 'pools' ?
					<Help 
						{...this.props}
		                menu={"help_processed"} 
		                submenu={"help_reconstitution"}  />
				:null}

				<form noValidate>
					<div className="col-xs-12 form-group">

						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Número de Unidad</span>
							<input type="text" name="unit_number" id="unit_number" onKeyPress={(e) => this.searchComponent(e)} value={this.state.unit_number || ""} onChange={this.handleChange} className="form-control" />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Código Componente</span>
							
							<Typeahead
					          	labelKey={(option) => `${option.label}`}
					          	minLength={0}
					          	options={this.state.code_component_list.length > 0 ? this.state.code_component_list : []}
					          	onChange={this.onChangeComponent}	
					            inputProps={{
					          		name:"code",
					          		id:"code"
					          	}}
					          	id="code_component"
					          	isLoading={this.state.isLoading}
					          	ref={ref => this._typeahead = ref}
					          	delay={600}
					          	paginationText="Mostrar mas resultados..."
					        />
						</div>
							

						<div className="col-xs-12 col-sm-2">
							<FloatingActionButton className="action-btn"  mini={true} style={{marginTop:'18px'}} 
								iconStyle={{height: 25, width: 25}} onClick={this.addComponent} >
		                      	<ContentAdd/>
		                    </FloatingActionButton> 
						</div>

						
						
					</div>

					<div className="col-xs-12 form-group">
						<Table responsive hover>
							<thead>
									{submenu === 'pools' ?
										<tr>
											<th></th>
											<th>No Unidad</th>
											<th>Componente</th>
											<th>No Componente</th>
											<th>Caducidad</th>
											<th>Volumen</th>
											<th>Grupo y RH</th>
											<th></th>
										</tr>

									: 	<tr>
											<th>No Unidad</th>
											<th>Componente</th>
											<th>Caducidad</th>
											<th>Volumen</th>
											<th>Grupo y RH</th>
											<th></th>
										</tr>
									}
							</thead>
							<tbody>
								{submenu === 'pools' ?
									this.state.components.map((c, i)=>{
										return <tr key={i}>
												<td>
													<input type="checkbox" onKeyPress={(e) => this.validateInput(e)} onChange={this.onChecked} id={this.state.checks[i] !== undefined ? this.state.checks[i].id : c.unit.id} 
													    checked={this.state.checks[i] !== undefined ? this.state.checks[i].check : false} />
												</td>
												<td>
													{c.donation_number !== "" && c.donation_number !== null ? 
														c.donation_number :
													c.unit.unit_number}
												</td>
												<td>{c.blood_component.component}</td>
												<td>{c.unit.component_number}</td>
												<td>
													<Moment format="DD/MM/YYYY">{c.unit.caducidad}</Moment>
												</td>
												<td className="td-number">{c.unit.volume}</td>
												<td>{c.unit.group}
													{c.unit.rh === "POSITIVO" ?"+":"-"}
												</td>
												<td>
													<button type="button" className="btn btn-info" type="button" onClick={this.deleteComponent.bind(this,c.unit.id)} 
														onKeyPress={(e) => this.validateInput(e)}
														style={{borderRadius:"100%", padding: "4px 5px", boxShadow: "-1px 3px 6px 0 rgba(0,0,0,0.24), 0 17px 50px 0 rgba(0,0,0,0.16)"}} 
														>
														<SvgIcon icon={bin}/>
													</button>
												</td>
											</tr>
									})

								: this.state.components.map((c, i)=>{
										return <tr key={i}>
												<td>{c.unit.unit_number}</td>
												<td>{c.blood_component.component}</td>
												<td>
													<Moment format="DD/MM/YYYY">{c.unit.caducidad}</Moment>
												</td>
												<td className="td-number">{c.unit.volume}</td>
												<td>{c.unit.group}
													{c.unit.rh === "POSITIVO" ?"+":"-"}
												</td>
												<td>
													<button type="button" className="btn btn-info" type="button" onClick={this.deleteComponent.bind(this,c.unit.id)} 
														onKeyPress={(e) => this.validateInput(e)}
														style={{borderRadius:"100%", padding: "4px 5px", boxShadow: "-1px 3px 6px 0 rgba(0,0,0,0.24), 0 17px 50px 0 rgba(0,0,0,0.16)"}} 
														>
														<SvgIcon icon={bin}/>
													</button>
												</td>
											</tr>
									})
								} 
							</tbody>
						</Table>
					</div>

					{submenu !== 'pools' ?
						<div className="col-xs-12 col-xs-2 col-sm-offset-5 form-group" style={{textAlign:"center"}}>
							<button className="btn btn-info"  style={{fontSize:"1em"}} type="button" onClick={this.onCreate}>
								{submenu === 'pools' ? 'Crear POOL' : 'Crear '} 
							</button>
						</div>
					:null}

					<div className="col-xs-12 col-sm-10 col-sm-offset-1 form-group reconstitution">
						<div className="col-xs-12 form-group" style={{padding:"0px"}}>
							<div className="col-xs-12 col-sm-3">
								<span className="span-min">Fecha</span>
								<input type="date" name="date" id="date" onChange={this.handleChange} onKeyPress={(e) => this.validateInput(e)} 
									value={this.state.date || ""} className="form-control" required 
									disabled={submenu === 'pools'} />
							</div>

							<div className="col-xs-12 col-sm-3">
								<span className="span-min">Hora</span>
								<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
									data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
									required onKeyPress={(e)=>this.validateInput(e)} className="form-control"/>
							</div>

							{submenu === 'pools' ? 
								<div className="col-xs-12 col-sm-6">
									<span className="span-min">Componente Final</span>
									
									<select name="final_component" id="final_component" className="form-control" required
										onChange={this.handleChange} value={this.state.final_component || ""}>
										<option value="">Seleccione...</option>
										{this.state.final_components.map((c, i)=>(
											<option key={i} value={c.id}>
												{c.component}
											</option>
										))}
									</select>
									
									
								</div>
							:null}
						</div>

						<div className="col-xs-12 form-group" style={{padding:"0px"}}>
							<div className="col-xs-12 col-sm-6">
								<span className="span-min">Componente Sanguíneo</span>
								<input type="text" onKeyPress={(e) => this.validateInput(e)} className="form-control" 
									value={this.state.code_pool || ""} disabled />
							</div>

							<div className="col-xs-12 col-sm-6" style={{paddingTop:"18.5px"}}>
								<input type="text" onKeyPress={(e) => this.validateInput(e)} className="form-control" 
									value={this.state.component_pool || ""} disabled />
							</div>
						</div>

						<div className="col-xs-12 form-group" style={{padding:"0px"}}>
							<div className="col-xs-12 col-sm-6">
								<span className="span-min">Unidad Número</span>
								<input type="text" onKeyPress={(e) => this.validateInput(e)} className="form-control" 
									value={this.state.unit_number_pool || ""} disabled />
							</div>

							<div className="col-xs-12 col-sm-6">
								<span className="span-min">Grupo Sanguíneo</span>
								{submenu === 'pools' ?
									<select name="group_rh" id="group_rh" className="form-control" required
										onChange={this.handleChange} value={this.state.group_rh || ""}>
										<option value="">Seleccione...</option>
										{this.state.group_rh_list.map((g, i)=>{
											return <option key={i} value={g.group}>
												{g.group}
											</option>
										})}
									</select>
								: <input type="text" name="group_rh" id="group_rh" className="form-control" disabled
										value={this.state.group_rh || ""}  />
								}
								
							</div>
						</div>

						<div className="col-xs-12 col-sm-6 form-group">
							<span className="span-min" style={{display:"block"}}>Volumen (ml)</span>
							<input type="number" name="volume_pool" id="volume_pool" required onChange={this.handleChange} 
								onKeyPress={(e) => this.validateInput(e)} className="form-control" 
								value={this.state.volume_pool || ""} />
						</div>

						<div className="col-xs-12 col-sm-6 form-group">
							<span className="span-min">{submenu === 'pools' ? "Bolsa Lote Número" : "Hematocrito"}</span>
							<input type="text" name={submenu === 'pools' ? "bag_lot" : "hematocrit"} id={submenu === 'pools' ? "bag_lot" : "hematocrit"} 
								className="form-control" value={submenu === 'pools' ? this.state.bag_lot : this.state.hematocrit } 
								onChange={this.handleChange} onKeyPress={(e) => this.validateInput(e)} />
						</div>

						<div className="col-xs-12 col-sm-6 form-group">
							<span className="span-min">{submenu === 'pools' ? "Solución Aditiva" : "Bolsa Lote Número" }</span>
							<input type="text" onKeyPress={(e) => this.validateInput(e)} className="form-control"
								name={submenu === 'pools' ? "aditive_solution" : "bag_lot"} id={submenu === 'pools' ? "aditive_solution" : "bag_lot"} 
								onChange={this.handleChange} value={submenu === 'pools' ? this.state.aditive_solution : this.state.bag_lot}/>
						</div>

						<div className="col-xs-12 col-sm-6 form-group">
							<span className="span-min">Fecha y Hora de Caducidad</span>
							<input type="datetime-local" value={this.state.caducidad || ""} onKeyPress={(e) => this.validateInput(e)} 
								onChange={this.handleChange} id="caducidad" name="caducidad" className="form-control" 
								disabled={this.state.rec_pool_system === "CERRADO" || this.state.sys_component === "CERRADO"}/>
						</div>	
					</div>

					{submenu === 'pools' ?
						<div className="col-xs-12 col-xs-2 col-sm-offset-5 form-group" style={{textAlign:"center"}}>
							<button className="btn btn-info"  style={{fontSize:"1em"}} type="button" onClick={this.onCreate}>
								{submenu === 'pools' ? 'Crear POOL' : 'Crear '} 
							</button>
						</div>
					:null}

				</form>



				{submenu === 'pools' ?
					<div className="col-xs-12 form-group" style={{marginTop:'10px', textAlign:'center'}}>
						<button className="toolIcon" onClick={this.onPrint}
							disabled={this.state.new_id.length === 0}>
							<SvgIcon size={40} icon={priceTag} />
							<div className="col-xs-12">
								<span>Etiqueta</span>
							</div>
						</button>
					</div>
				:null}
				<div className="col-xs-12" style={{textAlign:'center'}}>
		        	<div>
		        		{submenu === 'pools' ?
		        			this.state.btn_new ? 
		        				<RaisedButton className="action-btn" label={'Finalizar'} primary={true} onClick={this.onReturn}  style={{margin:12}}/>
		        			: <RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}/>
		        		: <RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave}  style={{margin:12}}/>}
		        		
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} onClick={this.onReturn} style={{margin:12}}/>
		        	</div>
		        </div>
		        <Notifications />
		        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(PoolsReconstruction);